import { ReactNode } from "react";

export type FeatureDetailsProps = {
  banner?: ReactNode;
  description?: ReactNode;
  feature?: ReactNode;
  button?: ReactNode;
};

export const FeatureDetails = ({
  banner,
  description,
  feature,
  button,
}: FeatureDetailsProps) => {
  const isDescriptionAbsent = !description && !feature;
  return (
    <section className="t-flex t-flex-col t-gap-7 t-w-full t-items-center">
      {banner && (
        <div className="sm:t-max-w-full sm:t-box-border sm:t-px-4">
          {banner}
        </div>
      )}
      {!isDescriptionAbsent && (
        <div className="t-flex t-flex-col t-gap-6 t-items-center t-max-w-[30.625rem] sm:t-w-full sm:t-box-border sm:t-px-4">
          {description && <div>{description}</div>}
          {feature && <div>{feature}</div>}
        </div>
      )}
      {button && <div>{button}</div>}
    </section>
  );
};
